/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/plus_mobile': {
    width: 17,
    height: 17,
    viewBox: '0 0 17 17',
    data: '<path pid="0" d="M17 8.5a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0z" _fill="#E25046"/><path pid="1" d="M7.492 14.243V9.478H2.757V7.487h4.735v-4.73h2.017v4.73h4.735v1.991H9.509v4.765H7.492z" _fill="#fff"/>'
  }
})
